import React from "react";
import FetchFeedback from "../../ui/CustomFetchFeedback/CustomFetchFeedback";
import CustomSkeletonTable from "../../ui/CustomSkeletonTable/CustomSkeletonTable";
import MerchantTableTanstack from "../tables/MerchantTableTanstack";
import MerchantEmptyState from "./MerchantEmptyState";

const MerchantTableContent = ({
  loadingData,
  isFetching,
  isError,
  onRetry,
  isTrueEmpty,
  isFilteredEmpty,
  filteredMerchants,
  onEdit,
  onToggleStatus,
  onMobileMoneyAdd,
  loadingIds,
  pagination,
  totalPages,
  totalElements,
  onPaginationChange,
}) => {
  if (isError) {
    return (
      <FetchFeedback
        message="Failed to load merchants. Please try again."
        onRetry={onRetry}
        fullHeight={false}
        compact
      />
    );
  }

  if (loadingData) {
    return <CustomSkeletonTable columns={[1, 2, 3, 4, 5]} rowCount={10} />;
  }

  if (isTrueEmpty || isFilteredEmpty) {
    return (
      <MerchantEmptyState
        isTrueEmpty={isTrueEmpty}
        isFilteredEmpty={isFilteredEmpty}
      />
    );
  }

  return (
    <MerchantTableTanstack
      data={filteredMerchants}
      onEdit={onEdit}
      onToggleStatus={onToggleStatus}
      onMobileMoneyAdd={onMobileMoneyAdd}
      loadingIds={loadingIds}
      pagination={pagination}
      totalPages={totalPages}
      totalElements={totalElements}
      onPaginationChange={onPaginationChange}
      isFetching={isFetching}
    />
  );
};

export default MerchantTableContent;
